@switch (lpConfig.googlePlayTemplate) {
  @case ('classic') {
    <pwa-classic-template
      [config]="lpConfig"
      [contentLanguageCode]="contentLanguageCode"
      [isInitialization]="isInitialization"
      [isAppInstalled]="isAppInstalled"
      [installResult]="(installResult$ | async) || ''"
      (open)="onOpenBtn()"
      (install)="onInstallBtn()"
    ></pwa-classic-template>
  }
  @case ('modern') {
    <pwa-modern-template
      [config]="lpConfig"
      [contentLanguageCode]="contentLanguageCode"
      [isInitialization]="isInitialization"
      [isAppInstalled]="isAppInstalled"
      [installResult]="(installResult$ | async) || ''"
      (open)="onOpenBtn()"
      (install)="onInstallBtn()"
    ></pwa-modern-template>
  }
}
